import styled from "styled-components";
import { FlexMixin, FontMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
export const FlatpickrCalendarWrapper = styled.div.withConfig({
    displayName: "styled__FlatpickrCalendarWrapper",
    componentId: "sc-718eca09-0"
})`
	.flatpickr-wrapper {
		display: block;
		position: relative;
		padding: 8px;
		.flatpickr-calendar {
			border-radius: 0;
			filter: none;
			max-height: unset;
			width: 100% !important;
			padding: 0;
			margin: 0;

			.flatpickr-months {
				${FlexMixin({
    direction: 'column',
    justify: 'flex-start'
})}

				.flatpickr-month {
					position: absolute;
					width: 100%;
					z-index: ${({ theme  })=>theme.zIndex.lowest};
					${FlexMixin({
    justify: 'center',
    align: 'center'
})}

					.flatpickr-current-month {
						position: relative;
						left: 0;
						width: auto;
						text-align: center;
						${FlexMixin({
    justify: 'center',
    align: 'center'
})};
						padding: 0;

						.cur-month {
							${FontMixin({
    weight: 'regular'
})}
							margin: 0;
						}

						.numInputWrapper {
							pointer-events: none;

							.cur-year {
								${FontMixin({
    size: 'base',
    weight: 'regular'
})}
								line-height: 1;
							}
						}
					}
				}

				.flatpickr-next-month,
				.flatpickr-prev-month {
					display: none;
				}
			}

			.flatpickr-innerContainer {
				padding-top: 88px;

				.flatpickr-rContainer {
					display: block;
					width: 100%;

					.flatpickr-weekdays {
						background-color: ${({ theme  })=>theme.colors.white.base};
						border-bottom: 1px solid ${({ theme  })=>theme.colors.grays.light};
						height: 46px;
						position: fixed;
						top: 0;
						width: 100%;
						z-index: ${({ theme  })=>theme.zIndex.lowest};
						padding: 0;

						.flatpickr-weekdaycontainer {
							display: none;

							&:first-of-type {
								${FlexMixin({
    justify: 'flex-start'
})}
							}

							.flatpickr-weekday {
								text-transform: uppercase;
							}
						}
					}

					.flatpickr-days {
						${FlexMixin({
    direction: 'column'
})}
						width: 100%!important;

						.dayContainer {
							margin-bottom: 52px;
							${FlexMixin({
    justify: 'space-between'
})}
							width: 100%;
							min-width: initial;
							max-width: initial;
							padding: 0;

							.flatpickr-day {
								border-radius: 8px;
								max-width: initial;
								${FontMixin({
    size: 'base'
})}
								height: 40px;
								border: none;
								box-shadow: none !important;

								&:hover {
									background: ${({ theme  })=>theme.colors.primary.lightest};
									border-color: ${({ theme  })=>theme.colors.primary.lightest};
								}

								&.today {
									color: ${({ theme  })=>theme.colors.primary.lighter};
								}

								&.startRange,
								&.endRange,
								&.selected {
									color: ${({ theme  })=>theme.colors.white.base};
									background: ${({ theme  })=>theme.colors.primary.lighter};
									border-color: ${({ theme  })=>theme.colors.primary.lighter};

									&:hover {
										background: ${({ theme  })=>theme.colors.primary.lighter};
										border-color: ${({ theme  })=>theme.colors.primary.lighter};
									}
								}

								&.startRange {
									border-radius: 8px 0 0 8px;
								}

								&.endRange {
									border-radius: 0 8px 8px 0;
								}

								&.inRange {
									background: ${({ theme  })=>theme.colors.primary.lightest};
									border-color: ${({ theme  })=>theme.colors.primary.lightest};
									color: ${({ theme  })=>theme.colors.primary.lighter};
									border-radius: 0;
								}
							}
						}
					}
				}
			}

			.flatpickr-day-footer {
				position: sticky;
				bottom: 0;
				background-color: ${({ theme  })=>theme.colors.white.base};
				padding: 16px;
				z-index: ${({ theme  })=>theme.zIndex.lowest};

				.flatpickr-day-footer-literal {
					${FontMixin({
    size: 'medium',
    height: 'medium'
})}
				}
			}

			&::after {
				display: none;
			}
		}
	}
`;
export const TimeValue = styled.div.withConfig({
    displayName: "styled__TimeValue",
    componentId: "sc-718eca09-1"
})`
	${FontMixin({
    size: 'base',
    height: 'base',
    weight: 'light'
})}
	padding: 16px;
	border-bottom: 2px solid ${({ theme  })=>theme.colors.primary.lighter};

	span {
		${FontMixin({
    weight: 'regular'
})}
	}
`;

//# sourceMappingURL=styled.js.map